var _style, _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information_svg__Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".information_svg__st0{fill:#3b3b3b}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "information_svg__st0",
    cx: 256,
    cy: 378.5,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "information_svg__st0",
    d: "M256 0C114.5 0 0 114.5 0 256s114.5 256 256 256 256-114.5 256-256S397.5 0 256 0zm0 472c-119.4 0-216-96.6-216-216S136.6 40 256 40s216 96.6 216 216-96.6 216-216 216z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "information_svg__st0",
    d: "M256 128.5c-44.1 0-80 35.9-80 80 0 11 9 20 20 20s20-9 20-20c0-22.1 17.9-40 40-40s40 17.9 40 40-17.9 40-40 40c-11 0-20 9-20 20v50c0 11 9 20 20 20s20-9 20-20V286c34.5-8.9 60-40.3 60-77.5 0-44.1-35.9-80-80-80z"
  })));
}

export default __webpack_public_path__ + "070158e9f289aee6c7067ffbf38530e7.svg";
export { SvgInformation as ReactComponent };